<template>
  <div
    v-if="!labelInsideTextarea"
    class="custom-textarea"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <textarea
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="event => this.$emit('update', event.target.value)"
    />
  </div>

  <md-field
    v-else
    :class="['input', { 'md-invalid': errors.length }]">

    <label v-if='label'>
      {{ label }}
    </label>

    <md-textarea
      :value="value"
      @input="onChange"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="inputProps"
    />
    <span
        class='md-error'
        v-if='errors.length'
        v-for='error in errors'
    >
      {{ $t(`errors.${error}`) }}
    </span>
  </md-field>
</template>

<script>
  export default {
    name: 'x-textarea',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      labelInsideTextarea: {
        type: Boolean,
        default: true
      },
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onChange (value) {
        this.$emit('update', value)
      }
    }
  }
</script>


<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .custom-textarea {
    label {
      display: block;
      color: $color-galaxy;
      font-size: 1.4rem;
      margin-left: $space-medium;
      margin-bottom: $space-small;
      font-weight: 600;
    }

    textarea {
      width: 100%;
      max-width: 100%;
      padding: $space-medium;
      border: 0.1rem solid $color-ghost;
      border-radius: 0.2rem;
      font-size: 1.4rem;
      font-family: inherit;

      &:focus {
        outline-color: map_get($palette-primary, main);
      }

      &::placeholder {
        color: #DBDCDF;
        font-size: 1.3rem;
      }
    }
  }
</style>